(() => {
  const initCarouselCounter = (root = document) => {
    root.querySelectorAll('.our-team__carousel').forEach((carousel) => {
      if (carousel.dataset.teamCounterReady === 'true') return;
      carousel.dataset.teamCounterReady = 'true';

      const current = carousel.querySelector('.our-team__counter-current');
      const total = carousel.querySelector('.our-team__counter-total');
      const slides = carousel.querySelectorAll('xo-carousel-slide');
      if (!current || !total || slides.length === 0) return;

      total.textContent = String(slides.length);

      const update = (event) => {
        const activeIndex = Number(event?.detail?.activeIndex || 0);
        const visibleIndex = Math.min(Math.max(activeIndex + 1, 1), slides.length);
        current.textContent = String(visibleIndex);
      };

      carousel.addEventListener('xo:carousel:init', update);
      carousel.addEventListener('xo:carousel:change', update);
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCarouselCounter());
  } else {
    initCarouselCounter();
  }

  document.addEventListener('shopify:section:load', (event) => initCarouselCounter(event.target));
})();
